<template>
    <div class="container">
        <div class="content" id="printContent">
            <div class="header tac fs20 fwb border">
                {{ invoice.header_name }}-{{ system.name }}
                <span class="time fs14 color666">申请时间：{{ invoice.create_time.substr(0, 10) }}</span>
            </div>
            <div class="fs20 mgt20 mgb20 fwb tac">收费明细</div>
            <div class="mgt20"> {{ invoice.name }}：</div>
            <div class="mgt20">您的项目已完成，请按以下收费清单办理付费，谢谢! </div>
            <table class="mgt20">
                <thead>
                    <tr>
                        <th>项目</th>
                        <th>单价</th>
                        <th>数量</th>
                        <th>金额</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in invoice.items" :key="index">
                        <td class="tac">{{ item.body }}</td>
                        <td class="tac">{{ item.price }}</td>
                        <td class="tac">{{ item.num || 1 }}</td>
                        <td class="tac">{{ item.price }}</td>
                    </tr>

                </tbody>
            </table>

            <div class="row fwb mgt20 border">
                <span class="fl">合计金额(小写)：</span>
                <span class="fr">{{ invoice.price }}</span>
                <div class="clearfix"></div>
            </div>

            <div class="row fwb mgt20">
                <span class="fl"> 合计金额人民币(大写)： </span>
                <span class="fr">{{ invoice.big_price }}</span>
                <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
            <div class="bottom mgt100">
                <div class="tar pdr30">{{ invoice.header_name }}</div>
                <div class="tar mgt20 pdr30">{{ invoice.create_time.substr(0, 10) }}</div>
                <img class="chapter" :src="invoice.header_chapter" alt="" />
            </div>

        </div>

        <div class="footer mgt100 flex-xy-center">
            <div>
                <el-button type="primary" @click="handleDownload">下载清单</el-button>
            </div>
            <div class="mgl50">
                <el-button type="primary" v-print="'#printContent'" :loading="loading">打印清单</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { getPrintPreview } from "@/api/invoice";

export default {
    name: 'InvoicePreviewList',
    components: {

    },
    data() {
        return {
            loading: true,
            invoice: {
                create_time: ''
            },
            invoiceId: 0,
            system: {},
            account: {},
        };
    },
    computed: {

    },
    created() {
        this.invoiceId = this.$route.query.id;
        this.getPrintPreview();
    },
    methods: {
        getPrintPreview() {
            getPrintPreview({ id: this.invoiceId }).then(res => {
                this.loading = false;
                this.invoice = res.data.invoice;
                this.system = res.data.system;
                this.account = res.data.account;
            }).catch((err) => {

            });
        },
        handleDownload() {
            window.open(this.invoice.list_url, '_blank');
        },
    }
};
</script>

<style media="printContent">
@page {
    margin: 5mm;
}
</style>
<style lang="scss" scoped>
.container {
    width: 700px;
    margin: 0 auto;
    padding-bottom: 30px;
    background-color: #FFF;
}

.content {
    padding: 30px 30px 0 30px;
}

.header {
    position: relative;
    padding-bottom: 20px;
}

.header .time {
    position: absolute;
    left: 50%;
    margin-left: 150px;
    top: 10px;
    font-weight: normal;
}

table {
    width: 100%;
}


table td,
table th {
    padding: 10px 20px;
    border: 1px solid #666;
    font-size: 13px;
}

.border {
    border-bottom: 1px solid #666;
}

.row {
    padding-bottom: 20px;
}

.bottom {
    position: relative;
    height: 200px;
}

.chapter {
    position: absolute;
    right: 0px;
    bottom: 70px;
    width: 200px;
    height: 200px;
    z-index: 1;
}

.clearfix::after {
    content: "";
    display: table;
    clear: both;
}
</style>
